import React, { useEffect, useState } from "react";
import AddButton from "../../../components/admin/usable/AddButton";
import CancelButton from "../../../components/admin/usable/CancelButton";
import { useDispatch, useSelector } from "react-redux";
import {
  setForAll,
  setIsSingleSelected,
  setShowFileUploader,
  setSingleSelected,
} from "../../../redux/admin/fileManagerSlice";
import FileUploadandSelect from "../../../components/admin/usable/fileuploader/FileUploadandSelect";
import {
  addCompany,
  getSingleCompany,
  updateCompany,
} from "../../../api/admin/companyApi";
import { useNavigate, useParams } from "react-router";
import toast from "react-hot-toast";

const EditCompany = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [FormData, setFormData] = useState({
    id: "",
    companyName: "",
    companyLogo: "",
    address: "",
    primaryPhoneNumber: "",
    alternativePhoneNumber: "",

    email: "",
    password: "",

    commissionRate: 0,
    type: "Hotel",

    koc_fullName: "",
    koc_profilePicture: "",
    koc_phoneNumber: "",
    koc_email: "",
    koc_designation: "",

    agreement: "",
    tradelicense: "",
    nid: "",
    bin: "",
    tin: "",
    incorporation: "",

    isVerified: 1,
    status: 1,
    created_by: 1,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  });
  const { showFileUploader, singleSelected } = useSelector(
    (state) => state.file,
  );
  const [activeUploadField, setActiveUploadField] = useState(null);

  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  useEffect(() => {
    dispatch(setForAll(true));
    dispatch(setIsSingleSelected(true));

    return () => {
      dispatch(setForAll(false));
      dispatch(setIsSingleSelected(false));
    };
  }, [dispatch]);

  useEffect(() => {
    if (singleSelected && activeUploadField) {
      setFormData((prevData) => ({
        ...prevData,
        [activeUploadField]: singleSelected.fileLink.medium || "",
      }));
      setActiveUploadField(null);
      dispatch(setSingleSelected(null));
    }
  }, [singleSelected, activeUploadField, dispatch]);
  useEffect(() => {
    getSingleCompany(id, setFormData);
  }, [id]);
  const handleUpload = (field) => {
    setActiveUploadField(field);
    dispatch(setShowFileUploader(true));
    dispatch(setForAll(true));
  };
  const handleRemoveImage = (field) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: "",
    }));
  };
  const handleSubmit = () => {
    if (
      FormData.companyName === "" ||
      FormData.address === "" ||
      FormData.primaryPhoneNumber === "" ||
      FormData.alternativePhoneNumber === "" ||
      FormData.commissionRate === "" ||
      FormData.type === ""
    ) {
      toast.error("Please fill all required fields");
    } else {
      updateCompany(FormData, navigate);
    }
  };
  const handleReset = () => {
    setFormData({
      companyName: "",
      companyLogo: "",
      address: "",
      primaryPhoneNumber: "",
      alternativePhoneNumber: "",
      email: "",
      password: "",
      commissionRate: 0,
      type: "Hotel",
      koc_fullName: "",
      koc_profilePicture: "",
      koc_phoneNumber: "",
      koc_email: "",
      koc_designation: "",
      agreement: "",
      tradelicense: "",
      nid: "",
      bin: "",
      tin: "",
      incorporation: "",
      isVerified: 1,
      status: 1,
      created_by: 1,
      createdAt: new Date().toISOString(),
    });
  };
  return (
    <>
      {showFileUploader && <FileUploadandSelect />}
      <div className="w-full h-auto">
        <div className="space-y-10 py-4">
          <div className="p-4 border rounded-lg  bg-white space-y-5">
            <div className="text-center uppercase">
              <p className="font-semibold">Company Information</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-xs" htmlFor="">
                  Company Name
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Company Name"
                  id="companyName"
                  value={FormData.companyName}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Address
                </label>
                <textarea
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Company Address"
                  id="address"
                  value={FormData.address}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Primary Phone Number
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Primary Phone Number"
                  id="primaryPhoneNumber"
                  value={FormData.primaryPhoneNumber}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Alternative Phone Number
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Alternative Phone Number"
                  id="alternativePhoneNumber"
                  value={FormData.alternativePhoneNumber}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Company Logo
                </label>
                <div className="relative w-40 h-40">
                  <img
                    className="w-40 h-40 object-cover rounded-lg"
                    src={
                      FormData.companyLogo ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  {FormData.companyLogo && (
                    <div
                      onClick={() => handleRemoveImage("companyLogo")}
                      className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                    >
                      <p className="text-xs">Remove</p>
                    </div>
                  )}
                  <div
                    onClick={() => handleUpload("companyLogo")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-40 h-40"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
              <div className="space-y-3">
                <div>
                  <label className="text-xs" htmlFor="">
                    Company Type
                  </label>
                  <select
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                    id="type"
                    value={FormData.type}
                    onChange={handleChange}
                  >
                    <option value="">Select Type</option>
                    <option value="Hotel">Hotel</option>
                    <option value="Tour">Tour</option>
                    <option value="Flight">Flight</option>
                    <option value="Car">Car</option>
                    <option value="Ship">Ship</option>
                  </select>
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Commission Rate
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                    placeholder="Commission Rate (%)"
                    id="commissionRate"
                    value={FormData.commissionRate}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 border rounded-lg  bg-white space-y-5">
            <div className="text-center uppercase">
              <p className="font-semibold">Company Credential</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-xs" htmlFor="">
                  Email
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Email Address"
                  id="email"
                  value={FormData.email}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Password
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Password"
                  id="password"
                  value={FormData.password}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="p-4 border rounded-lg  bg-white space-y-5">
            <div className="text-center uppercase">
              <p className="font-semibold">Key of Contact Information</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-xs" htmlFor="">
                  Full Name
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Full Name"
                  id="koc_fullName"
                  value={FormData.koc_fullName}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Designation
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Designation"
                  id="koc_designation"
                  value={FormData.koc_designation}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Email
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Email Address"
                  id="koc_email"
                  value={FormData.koc_email}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Phone Number
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none"
                  placeholder="Phone Number"
                  id="koc_phoneNumber"
                  value={FormData.koc_phoneNumber}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Profile Picture
                </label>
                <div className="relative w-40 h-40">
                  <img
                    className="w-40 h-40 object-cover rounded-lg"
                    src={
                      FormData.koc_profilePicture ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  {FormData.koc_profilePicture && (
                    <div
                      onClick={() => handleRemoveImage("koc_profilePicture")}
                      className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                    >
                      <p className="text-xs">Remove</p>
                    </div>
                  )}
                  <div
                    onClick={() => handleUpload("koc_profilePicture")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-40 h-40"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 border rounded-lg  bg-white space-y-5">
            <div className="text-center uppercase">
              <p className="font-semibold">Documents</p>
            </div>
            <div className="flex flex-wrap justify-start lg:justify-center items-center gap-4">
              <div>
                <label className="text-xs" htmlFor="">
                  Agreement
                </label>
                <div className="relative w-40 h-40 ">
                  <img
                    className="w-40 h-40 object-cover rounded-lg "
                    src={
                      FormData.agreement ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  {FormData.agreement && (
                    <div
                      onClick={() => handleRemoveImage("agreement")}
                      className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                    >
                      <p className="text-xs">Remove</p>
                    </div>
                  )}
                  <div
                    onClick={() => handleUpload("agreement")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-40 h-40"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  NID
                </label>
                <div className="relative w-40 h-40">
                  <img
                    className="w-40 h-40 object-cover rounded-lg"
                    src={
                      FormData.nid ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  {FormData.nid && (
                    <div
                      onClick={() => handleRemoveImage("nid")}
                      className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                    >
                      <p className="text-xs">Remove</p>
                    </div>
                  )}
                  <div
                    onClick={() => handleUpload("nid")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-40 h-40"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Trade License
                </label>
                <div className="relative w-40 h-40">
                  <img
                    className="w-40 h-40 object-cover rounded-lg"
                    src={
                      FormData.tradelicense ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  {FormData.tradelicense && (
                    <div
                      onClick={() => handleRemoveImage("tradelicense")}
                      className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                    >
                      <p className="text-xs">Remove</p>
                    </div>
                  )}
                  <div
                    onClick={() => handleUpload("tradelicense")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-40 h-40"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  BIN Certificate
                </label>
                <div className="relative w-40 h-40">
                  <img
                    className="w-40 h-40 object-cover rounded-lg"
                    src={
                      FormData.bin ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  {FormData.bin && (
                    <div
                      onClick={() => handleRemoveImage("bin")}
                      className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                    >
                      <p className="text-xs">Remove</p>
                    </div>
                  )}
                  <div
                    onClick={() => handleUpload("bin")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-40 h-40"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  TIN Certificate
                </label>
                <div className="relative w-40 h-40">
                  <img
                    className="w-40 h-40 object-cover rounded-lg"
                    src={
                      FormData.tin ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  {FormData.tin && (
                    <div
                      onClick={() => handleRemoveImage("tin")}
                      className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                    >
                      <p className="text-xs">Remove</p>
                    </div>
                  )}
                  <div
                    onClick={() => handleUpload("tin")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-40 h-40"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Incorporation Certificate
                </label>
                <div className="relative w-40 h-40">
                  <img
                    className="w-40 h-40 object-cover rounded-lg"
                    src={
                      FormData.incorporation ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  {FormData.incorporation && (
                    <div
                      onClick={() => handleRemoveImage("incorporation")}
                      className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                    >
                      <p className="text-xs">Remove</p>
                    </div>
                  )}
                  <div
                    onClick={() => handleUpload("incorporation")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-40 h-40"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 border rounded-lg  bg-white space-y-5">
            <div className="flex justify-center items-center gap-4">
              <AddButton onClick={handleSubmit} text="Add Company" />
              <CancelButton onClick={handleReset} text="Cancel" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditCompany;
